import React from 'react';
import {
  AimOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';

import { OrbitWorkspaceTag } from './types';

export interface IOrbitWorkspace {
  tag: OrbitWorkspaceTag;
  title: string;
  subtitle: string;
  Icon: React.ComponentType;
}

/** The five Workspaces a chat can be filed in, in product order. */
export const ORBIT_WORKSPACES: readonly IOrbitWorkspace[] = [
  {
    tag: 'customer_insights',
    title: 'Customer Insights',
    subtitle: 'Explore customer behavior and engagement',
    Icon: BarChartOutlined
  },
  {
    tag: 'customer_360',
    title: 'Customer 360',
    subtitle: 'View unified customer profiles',
    Icon: UserOutlined
  },
  {
    tag: 'growth_planner',
    title: 'Growth Planner',
    subtitle: 'Identify opportunities and plan growth',
    Icon: AimOutlined
  },
  {
    tag: 'config_studio',
    title: 'Config Studio',
    subtitle: 'Set up campaigns, rewards and rules',
    Icon: SettingOutlined
  },
  {
    tag: 'overwatch',
    title: 'Overwatch',
    subtitle: 'Monitor data, quality and health',
    Icon: AppstoreOutlined
  }
];

export const findOrbitWorkspace = (tag: string | null | undefined): IOrbitWorkspace | undefined =>
  ORBIT_WORKSPACES.find(workspace => workspace.tag === tag);
